module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-09-16 at 12.11.57 PM (1).26af9824.jpeg";